import { render, staticRenderFns } from "./badDebtsList.vue?vue&type=template&id=2340c7c2&scoped=true&"
import script from "./badDebtsList.vue?vue&type=script&lang=js&"
export * from "./badDebtsList.vue?vue&type=script&lang=js&"
import style0 from "./badDebtsList.vue?vue&type=style&index=0&id=2340c7c2&lang=scss&scoped=true&"
import style1 from "./badDebtsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340c7c2",
  null
  
)

export default component.exports